export default {
  name: {
    number: "Purchase Order Number",
    date: "Date",
    end_date: "Delivery Date",
  },
};
